module.exports = __webpack_public_path__ + "static/hero-section-d0eea4b2c53b3836b0a20802cbb3e4eb.jpg";